function cov_1vjsa3ppix() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft.tsx";
  var hash = "632e5e0c3812891ff86b9e96289f50601a68a834";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "632e5e0c3812891ff86b9e96289f50601a68a834"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vjsa3ppix = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1vjsa3ppix();
var Icon = (cov_1vjsa3ppix().s[0]++, {
  name: 'chevron-left',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.476 18.7809C16.0448 19.32 15.2582 19.4074 14.7191 18.9761L7.21909 12.9761C6.92257 12.7389 6.74995 12.3797 6.74995 12C6.74995 11.6203 6.92257 11.2611 7.21909 11.0239L14.7191 5.02393C15.2582 4.59267 16.0448 4.68007 16.476 5.21915C16.9073 5.75822 16.8199 6.54484 16.2808 6.9761L10.0009 12L16.2808 17.0239C16.8199 17.4552 16.9073 18.2418 16.476 18.7809Z\" fill=\"currentColor\"/>"
});
export default Icon;